// AI Generated Test
import { Component, OnInit, OnDestroy } from '@angular/core';
import { QualityRepoService } from '@client/app/services/api/quality-repo/quality-repo.service';
import { PagesTabsHelper } from '@client/app/blocks/helpers/pages-tabs.helper';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { ENTITY_CONSTANT } from '@client/app/core/constants/entity.constant';
import { BaseEntityService } from '@client/app/blocks/base/base.entity.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'quality-pages',
    standalone: false,
    template: `
        <page-header
                [icon]="(['QA', 'CONTENT'] | monIcons)"
            header="{{'Issues by Page' | translate}}"
                [subHeader]="subheaderTranslation">
        </page-header>
        <mon-tabs
                [options]="tabs"
                [(status)]="activeTab"
                (onStatus)="onStatusChange($event)"
                (onSearch)="onSearchChange($event)"
                [search]="search"
                [minSearchLength]="1"
                [showFiltersBtn]="showFilters"
                [(isFiltersOpen)]="isFiltersOpen"
                [showSearch]="true">
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <pages-table
                        [pages]="pages"
                        [showNotifications]="showNotifications"
                        (onPageSort)="onPageSort($event)"
                        (onPageChange)="onPageChangeHandler($event)"
                        (onPerPageChange)="onPageSizeChangeHandler($event)"
                        [tab]="activeTab"
                        [currentSort]="currentSort"
                        [progress]="promise"
                        [(isFiltersOpen)]="isFiltersOpen"
                        [target]="'page-details-section-qa'"
                        (onFiltersChanges)="onFiltersChanges($event)">
                </pages-table>
            </div>
        </div>
    `,
})
export class QualityPagesComponent extends BaseContainerComponentController implements OnInit, OnDestroy {
    pages: any = [];
    tabs: any = [];
    showNotifications: any = ['dead-links', 'broken-images', 'misspellings'];
    override isFiltersOpen: boolean = false;
    override showFilters: boolean = false;
    issues: any = [];
    subheaderTranslation: string = '';
    override selectedLabels: any = [];
    override selectedLanguages: any = [];
    promise: any;
    eventId: any;
    override currentSort: any = { by: 'priority_score', direction: 'desc' };

    constructor (
        private qualityRepoService: QualityRepoService,
        private pagesTabsHelper: PagesTabsHelper,
        private activeFeatures: ActiveFeatureService,
        private baseEntityService: BaseEntityService,
        private translateService: TranslateService,
    ) {
        super({ table: true });
    }

    ngOnInit () {
        this.eventId = this.monEventsService.addListener(
            ENTITY_CONSTANT.PAGE_UPDATED_EVENT as any,
            this.baseEntityService.updateEntryInArray(this, 'pages', 'id'),
        );

        this.currentSort = { by: 'priority_score', direction: 'desc' };
        this.search = '';
        this.pages = [];
        this.tabs = this.pagesTabsHelper.getTabs();
        this.activeTab = this.pagesTabsHelper.getActiveTab() || 'all';
        this.showNotifications = ['dead-links', 'broken-images', 'misspellings'];
        this.isFiltersOpen = false;
        this.showFilters = this.activeFeatures.isFeatureActive('table_filters');
        this.issues = [];
        this.subheaderTranslation = '';

        this.getPage();
    }

    ngOnDestroy () {
        this.monEventsService.remove(this.eventId);
    }

    override getPage = () => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by === 'notification_count' ? 'quality_notification_count' : this.currentSort.by,
            sort_dir: this.currentSort.direction,
            qa_errors: true,
            search: this.search || null,
        };

        this.updateParamsWithIssuesFilters(params);

        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }

        if (this.selectedLanguages && this.selectedLanguages.length > 0) {
            params['languages[]'] = this.selectedLanguages;
        }

        if (this.activeTab !== 'all') {
            params['types[]'] = [this.activeTab];
        }

        this.promise = this.qualityRepoService.getAll(params).then((data: any) => {
            this.pages = data;
            this.getSubHeaderDescription();
        }, () => {});
    };

    private getSubHeaderDescription () {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')(this.pages.total, '0,0'),
            '1 page',
            '[[$count]] pages',
            {},
            '',
        );
    }

    private updateParamsWithIssuesFilters (params: any) {
        for (let i = 0; i < this.issues.length; i++) {
            params[this.issues[i].id] = true;
        }
        return params;
    }

    onPageSort (event: any) {
        this.page = 1;
        this.currentSort = { by: event.by, direction: event.direction };
        this.getPage();
    }

    onSearchChange (event: any) {
        this.onSearch(event);
    }

    onPageChangeHandler (event: any) {
        this.onPageChange(event);
    }

    onPageSizeChangeHandler (event: any) {
        this.onPageSizeChange(event);
    }

    onStatusChange (event: any) {
        this.onTabChange(event);
    }

    onFiltersChanges (changes: any) {
        if (changes.labels) {
            this.selectedLabels = changes.labels.map((label: any) => {
                return label.id;
            });
        } else {
            this.selectedLabels = [];
        }

        if (changes.languages) {
            this.selectedLanguages = changes.languages.map((language: any) => {
                return language.lang;
            });
        } else {
            this.selectedLanguages = [];
        }

        if (changes.contains) {
            this.issues = changes.contains;
        } else {
            this.issues = [];
        }

        this.getPage();
    }
}
